export enum Messengers {
  Telegram,
  Skype,
}
